function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.3838 2.27045H3.38379C2.8315 2.27045 2.38379 2.71816 2.38379 3.27045V17.2704C2.38379 17.8227 2.8315 18.2704 3.38379 18.2704H17.3838C17.9361 18.2704 18.3838 17.8227 18.3838 17.2704V3.27045C18.3838 2.71816 17.9361 2.27045 17.3838 2.27045ZM3.38379 0.270447C1.72694 0.270447 0.383789 1.61359 0.383789 3.27045V17.2704C0.383789 18.9273 1.72693 20.2704 3.38379 20.2704H17.3838C19.0406 20.2704 20.3838 18.9273 20.3838 17.2704V3.27045C20.3838 1.61359 19.0406 0.270447 17.3838 0.270447H3.38379Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.38379 5.27045H11.3838V15.2704H9.38379V5.27045Z",
  fill: "#4979C0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3838 11.2704H15.3838V15.2704H13.3838V11.2704Z",
  fill: "#4979C0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.38379 8.27045H7.38379V15.2704H5.38379V8.27045Z",
  fill: "#4979C0"
});

var SvgAudit = function SvgAudit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audit.5309bf45.svg";
export { ForwardRef as ReactComponent };